// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Ubf6","inner":"Footer_inner__iCXPq","nextIcon":"Footer_nextIcon__28HNh","innerLeft":"Footer_innerLeft__3QEc0"};